import { render, staticRenderFns } from "./ProductsCompareSection.vue?vue&type=template&id=63bb57aa&"
import script from "./ProductsCompareSection.vue?vue&type=script&lang=js&"
export * from "./ProductsCompareSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports